export default __webpack_public_path__ + "static/media/area.b2855f69.svg";